import uuid from 'uuidv4';
export const DEFAULT_WAGES_AND_INCOME_STRUCTURE = {
  incomeChecklist: {
    absentFamilyMember: 'no',
    absentFamilyMemberHoursWeeksMonths: 0,
    absentFamilyMemberIncome: '0.00',
    absentFamilyMemberPayFrequency: '',
    absentFamilyMemberPayRate: '',
    // Child Support
    anticipateChildSupport: 'no',
    anticipateChildSupportCounty: '',
    anticipateChildSupportState: '',
    collectChildSupport: 'no',
    collectChildSupportCounty: '',
    collectChildSupportState: '',
    courtOrderedChildSupport: 'no',
    courtOrderedChildSupportHoursWeeksMonths: 0,
    courtOrderedChildSupportIncome: '0.00',
    courtOrderedChildSupportPayFrequency: '',
    courtOrderedChildSupportPayRate: '',
    receivingChildSupport: 'no',
    receivingChildSupportHoursWeeksMonths: 0,
    receivingChildSupportIncome: '0.00',
    receivingChildSupportPayFrequency: '',
    receivingChildSupportPayRate: '',
    // Disability
    disability: 'no',
    disabilityHoursWeeksMonths: 0,
    disabilityIncome: '0.00',
    disabilityPayFrequency: '',
    disabilityPayRate: '',
    // Employment
    employment: 'no',
    employmentIncome: '0.00',
    selfEmployment: 'no',
    selfEmploymentHoursWeeksMonths: '',
    selfEmploymentIncome: '0.00',
    selfEmploymentPayFrequency: '',
    selfEmploymentPayRate: '',
    militaryPay: 'no',
    militaryPayHoursWeeksMonths: '',
    militaryPayIncome: '0.00',
    militaryPayPayFrequency: '',
    militaryPayPayRate: '',
    notWorking: 'no',
    employmentList: [
      //   {
      //     payType: 'basePay',
      //     PayRate: '20',
      //     PayFrequency: '',
      //     Income: '1040.00',
      //     HoursWeeksMonths: 0,
      //   },
    ],

    // Online Sources
    incomeFromOnlineSources: 'no',
    incomeFromOnlineSourcesHoursWeeksMonths: 0,
    incomeFromOnlineSourcesIncome: '0.00',
    incomeFromOnlineSourcesPayFrequency: '',
    incomeFromOnlineSourcesPayRate: '',

    // Other Income
    other: 'no',
    otherIncome: '0.00',
    otherIncomeType: '2aebab51-bce9-40d3-8224-a5c3039135dc',
    otherList: [
      //   {
      //     IncomeName: '',
      //     PayRate: '',
      //     HoursWeeksMonths: '0',
      //     PayFrequency: '',
      //     Income: '0.00',
      //     IncomeType: '2a6b409e-f73a-4c9d-8149-b5aba6692877',
      //   },
    ],
    // Pension
    pension: 'no',
    pensionHoursWeeksMonths: 0,
    pensionIncome: '0.00',
    pensionPayFrequency: 'monthly',
    pensionPayRate: '',
    // Public Housing - Voucher Question
    publicHousing: 'no',
    // Gifts
    recurringGift: 'no',
    recurringGiftHoursWeeksMonths: 0,
    recurringGiftIncome: '0.00',
    recurringGiftPayFrequency: '',
    recurringGiftPayRate: '',
    // Retirement
    retirement: 'no',
    retirementHoursWeeksMonths: 0,
    retirementIncome: '0.00',
    retirementPayFrequency: '',
    retirementPayRate: '',
    // Social Security
    socialSecurity: 'no',
    socialSecurityClaimNumber: '',
    socialSecurityHoursWeeksMonths: 0,
    socialSecurityIncome: '0.00',
    socialSecurityPayFrequency: '',
    socialSecurityPayRate: '',
    // Supplemental Security
    supplementalSecurity: 'no',
    supplementalSecurityClaimNumber: '',
    supplementalSecurityHoursWeeksMonths: '0',
    supplementalSecurityIncome: '0.00',
    supplementalSecurityPayFrequency: '',
    supplementalSecurityPayRate: '',
    // TANF
    tanf: 'no',
    tanfHoursWeeksMonths: 0,
    tanfIncome: '0.00',
    tanfPayFrequency: '',
    tanfPayRate: '',
    // Trust
    trust: 'no',
    trustHoursWeeksMonths: 0,
    trustIncome: '0.00',
    trustPayFrequency: '',
    trustPayRate: '',
    // Unemployment Benefits
    unemploymentBenefits: 'no',
    unemploymentBenefitsHoursWeeksMonths: 0,
    unemploymentBenefitsIncome: '0.00',
    unemploymentBenefitsPayFrequency: '',
    unemploymentBenefitsPayRate: '',
    // VA Benefits
    vaBenefits: 'no',
    vaBenefitsHoursWeeksMonths: 0,
    vaBenefitsIncome: '0.00',
    vaBenefitsPayFrequency: '',
    vaBenefitsPayRate: '',

    // No used in the form
    residentPaymentIncome: '0.00',
    hapPaymentIncome: '0.00',
    incomeConfirmation: true,
    isAltForm: true,
  },
  annualIncome: '0.00',
};

// From BE
export const OTHER_INCOME_TYPES = {
  business: uuid.fromString('IncomeType.Business'),
  generalAssistanceWelfare: uuid.fromString(
    'IncomeType.General Assistance Welfare',
  ),
  indianTrust: uuid.fromString('IncomeType.Indian Trust'),
  nonFederalWage: uuid.fromString('IncomeType.Non Federal Wage'),
  nonWageSource: uuid.fromString('IncomeType.Other Non Wage Source'),
  nonSpecified: uuid.fromString('IncomeType.Non Specified'),
};
